import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, inject } from '@angular/core';

import { LoadingSpinnerComponent } from '@UIparts/common/loading-spinner/mobile-ver/loading-spinner.component';
import { LoadingSpinnerBaseService } from '@VineyardLib/services/loading-spinner-wrapper.service';
import { DISABLE_ZOOM_STYLE_CLASS } from '@VineyardLibConstant/constant';

/**
 * スピナーの表示を制御するサービス
 */
@Injectable({
  providedIn: 'root',
})
export class LoadingSpinnerService extends LoadingSpinnerBaseService {
  private overlay = inject(Overlay);

  /**
   * 動的コンテンツをアプリケーションにレンダリングするためのPrtal
   */
  private componentPortal = new ComponentPortal(LoadingSpinnerComponent);

  /**
   * オーバーレイを管理するためのハンドル
   */
  private overlayRef = this.overlay.create({
    hasBackdrop: true,
    panelClass: DISABLE_ZOOM_STYLE_CLASS,
    positionStrategy: this.overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically(),
  });

  /**
   * スピナーの表示
   */
  override show(): void {
    this.overlayRef.attach(this.componentPortal);
    // スピナー表示中のズーム操作を防ぐため、スピナー背景（backdropElement）がattachにより生成された後にスタイルクラスを追加
    this.overlayRef.backdropElement?.classList.add(DISABLE_ZOOM_STYLE_CLASS);
  }

  /**
   * スピナーの非表示
   */
  override hide(): void {
    this.overlayRef.detach();
  }
}
